// Static LinkedIn geoUrn -> human-readable location dictionary.
// LinkedIn does not expose this mapping publicly, so the admin tool maintains its own.
// `id` is the numeric geoUrn passed to /adminPanel/createLinkedinSearchesByLocations.
//
// Countries are generated from the curated master list in tmp/locations.txt; the
// metro/region entries are kept as a separate, hand-verified set. `type` groups
// countries vs metropolitan areas/regions in the picker.

export type GeoUrnLocationType = 'country' | 'metro';

export interface GeoUrnLocation {
  id: string;
  name: string;
  type: GeoUrnLocationType;
}

// A named region (e.g. "LATAM + Caribbean") that expands to its member location ids.
export interface GeoUrnLocationGroup {
  name: string;
  locationIds: string[];
}

export const GEO_URN_LOCATIONS: GeoUrnLocation[] = [
  // Countries
  { id: '101240012', name: 'Afghanistan', type: 'country' },
  { id: '102845717', name: 'Albania', type: 'country' },
  { id: '106395874', name: 'Algeria', type: 'country' },
  { id: '106296266', name: 'Andorra', type: 'country' },
  { id: '105371935', name: 'Angola', type: 'country' },
  { id: '100270819', name: 'Antigua and Barbuda', type: 'country' },
  { id: '100446943', name: 'Argentina', type: 'country' },
  { id: '103030111', name: 'Armenia', type: 'country' },
  { id: '101452733', name: 'Australia', type: 'country' },
  { id: '103883259', name: 'Austria', type: 'country' },
  { id: '103226548', name: 'Azerbaijan', type: 'country' },
  { id: '106662619', name: 'Bahamas', type: 'country' },
  { id: '100425729', name: 'Bahrain', type: 'country' },
  { id: '106215326', name: 'Bangladesh', type: 'country' },
  { id: '102118611', name: 'Barbados', type: 'country' },
  { id: '101705918', name: 'Belarus', type: 'country' },
  { id: '100565514', name: 'Belgium', type: 'country' },
  { id: '105912732', name: 'Belize', type: 'country' },
  { id: '101519029', name: 'Benin', type: 'country' },
  { id: '103613266', name: 'Bhutan', type: 'country' },
  { id: '104379274', name: 'Bolivia', type: 'country' },
  { id: '102869081', name: 'Bosnia and Herzegovina', type: 'country' },
  { id: '105698121', name: 'Botswana', type: 'country' },
  { id: '106057199', name: 'Brazil', type: 'country' },
  { id: '103809722', name: 'Brunei', type: 'country' },
  { id: '105333783', name: 'Bulgaria', type: 'country' },
  { id: '100587095', name: 'Burkina Faso', type: 'country' },
  { id: '100800406', name: 'Burundi', type: 'country' },
  { id: '101679268', name: 'Cambodia', type: 'country' },
  { id: '102500897', name: 'Cameroon', type: 'country' },
  { id: '101174742', name: 'Canada', type: 'country' },
  { id: '105745966', name: 'Cape Verde', type: 'country' },
  { id: '100134827', name: 'Central African Republic', type: 'country' },
  { id: '104655384', name: 'Chad', type: 'country' },
  { id: '104621616', name: 'Chile', type: 'country' },
  { id: '102890883', name: 'China', type: 'country' },
  { id: '100876405', name: 'Colombia', type: 'country' },
  { id: '103069791', name: 'Comoros', type: 'country' },
  { id: '101739942', name: 'Costa Rica', type: 'country' },
  { id: '103295271', name: "Cote d'Ivoire", type: 'country' },
  { id: '104688944', name: 'Croatia', type: 'country' },
  { id: '106429766', name: 'Cuba', type: 'country' },
  { id: '106774002', name: 'Cyprus', type: 'country' },
  { id: '104508036', name: 'Czech Republic', type: 'country' },
  { id: '101271829', name: 'Democratic Republic of the Congo', type: 'country' },
  { id: '104514075', name: 'Denmark', type: 'country' },
  { id: '100371290', name: 'Djibouti', type: 'country' },
  { id: '100720695', name: 'Dominica', type: 'country' },
  { id: '105057336', name: 'Dominican Republic', type: 'country' },
  { id: '106373116', name: 'Ecuador', type: 'country' },
  { id: '106155005', name: 'Egypt', type: 'country' },
  { id: '106522560', name: 'El Salvador', type: 'country' },
  { id: '105141335', name: 'Equatorial Guinea', type: 'country' },
  { id: '104219996', name: 'Eritrea', type: 'country' },
  { id: '102974008', name: 'Estonia', type: 'country' },
  { id: '106768907', name: 'Eswatini', type: 'country' },
  { id: '100212432', name: 'Ethiopia', type: 'country' },
  { id: '102762290', name: 'Federated States of Micronesia', type: 'country' },
  { id: '105733447', name: 'Fiji', type: 'country' },
  { id: '100456013', name: 'Finland', type: 'country' },
  { id: '105015875', name: 'France', type: 'country' },
  { id: '104471338', name: 'Gabon', type: 'country' },
  { id: '106100033', name: 'Gambia', type: 'country' },
  { id: '106315325', name: 'Georgia', type: 'country' },
  { id: '101282230', name: 'Germany', type: 'country' },
  { id: '105769538', name: 'Ghana', type: 'country' },
  { id: '104677530', name: 'Greece', type: 'country' },
  { id: '104579260', name: 'Grenada', type: 'country' },
  { id: '100877388', name: 'Guatemala', type: 'country' },
  { id: '100099594', name: 'Guinea', type: 'country' },
  { id: '100115557', name: 'Guinea-Bissau', type: 'country' },
  { id: '105836293', name: 'Guyana', type: 'country' },
  { id: '100993490', name: 'Haiti', type: 'country' },
  { id: '107163060', name: 'Honduras', type: 'country' },
  { id: '101937718', name: 'Hungary', type: 'country' },
  { id: '100288700', name: 'Hungary', type: 'country' },
  { id: '103291313', name: 'Iceland', type: 'country' },
  { id: '105238872', name: 'Iceland', type: 'country' },
  { id: '102713980', name: 'India', type: 'country' },
  { id: '102478259', name: 'Indonesia', type: 'country' },
  { id: '101934083', name: 'Iran', type: 'country' },
  { id: '106725625', name: 'Iraq', type: 'country' },
  { id: '104738515', name: 'Ireland', type: 'country' },
  { id: '101620260', name: 'Israel', type: 'country' },
  { id: '103350119', name: 'Italy', type: 'country' },
  { id: '105126983', name: 'Jamaica', type: 'country' },
  { id: '101355337', name: 'Japan', type: 'country' },
  { id: '103710677', name: 'Jordan', type: 'country' },
  { id: '106049128', name: 'Kazakhstan', type: 'country' },
  { id: '100710459', name: 'Kenya', type: 'country' },
  { id: '104742735', name: 'Kiribati', type: 'country' },
  { id: '104640522', name: 'Kosovo', type: 'country' },
  { id: '103239229', name: 'Kuwait', type: 'country' },
  { id: '103490790', name: 'Kyrgyzstan', type: 'country' },
  { id: '100664862', name: 'Laos', type: 'country' },
  { id: '104341318', name: 'Latvia', type: 'country' },
  { id: '101834488', name: 'Lebanon', type: 'country' },
  { id: '103712797', name: 'Lesotho', type: 'country' },
  { id: '106579411', name: 'Liberia', type: 'country' },
  { id: '104036859', name: 'Libya', type: 'country' },
  { id: '100878084', name: 'Liechtenstein', type: 'country' },
  { id: '101464403', name: 'Lithuania', type: 'country' },
  { id: '104042105', name: 'Luxembourg', type: 'country' },
  { id: '101316508', name: 'Madagascar', type: 'country' },
  { id: '105587166', name: 'Malawi', type: 'country' },
  { id: '106808692', name: 'Malaysia', type: 'country' },
  { id: '102161637', name: 'Maldives', type: 'country' },
  { id: '100770782', name: 'Mali', type: 'country' },
  { id: '100961908', name: 'Malta', type: 'country' },
  { id: '106516799', name: 'Marshall Islands', type: 'country' },
  { id: '106950838', name: 'Mauritania', type: 'country' },
  { id: '106931611', name: 'Mauritius', type: 'country' },
  { id: '103323778', name: 'Mexico', type: 'country' },
  { id: '106178099', name: 'Moldova', type: 'country' },
  { id: '101352147', name: 'Monaco', type: 'country' },
  { id: '102396337', name: 'Mongolia', type: 'country' },
  { id: '100733275', name: 'Montenegro', type: 'country' },
  { id: '102787409', name: 'Morocco', type: 'country' },
  { id: '100474128', name: 'Mozambique', type: 'country' },
  { id: '104136533', name: 'Myanmar', type: 'country' },
  { id: '106682822', name: 'Namibia', type: 'country' },
  { id: '100348836', name: 'Nauru', type: 'country' },
  { id: '104630404', name: 'Nepal', type: 'country' },
  { id: '102890719', name: 'Netherlands', type: 'country' },
  { id: '105490917', name: 'New Zealand', type: 'country' },
  { id: '105517145', name: 'Nicaragua', type: 'country' },
  { id: '103550069', name: 'Niger', type: 'country' },
  { id: '105365761', name: 'Nigeria', type: 'country' },
  { id: '102356536', name: 'North Korea', type: 'country' },
  { id: '103420483', name: 'North Macedonia', type: 'country' },
  { id: '103819153', name: 'Norway', type: 'country' },
  { id: '103619019', name: 'Oman', type: 'country' },
  { id: '101022442', name: 'Pakistan', type: 'country' },
  { id: '106779877', name: 'Palau', type: 'country' },
  { id: '93000000', name: 'Palestine / Palestinian Territory', type: 'country' },
  { id: '100808673', name: 'Panama', type: 'country' },
  { id: '100152180', name: 'Papua New Guinea', type: 'country' },
  { id: '104065273', name: 'Paraguay', type: 'country' },
  { id: '102927786', name: 'Peru', type: 'country' },
  { id: '103121230', name: 'Philippines', type: 'country' },
  { id: '105072130', name: 'Poland', type: 'country' },
  { id: '100364837', name: 'Portugal', type: 'country' },
  { id: '104170880', name: 'Qatar', type: 'country' },
  { id: '106796687', name: 'Republic of the Congo', type: 'country' },
  { id: '106670623', name: 'Romania', type: 'country' },
  { id: '101728296', name: 'Russia', type: 'country' },
  { id: '103547315', name: 'Rwanda', type: 'country' },
  { id: '102098694', name: 'Saint Kitts and Nevis', type: 'country' },
  { id: '104022923', name: 'Saint Lucia', type: 'country' },
  { id: '104703990', name: 'Saint Vincent and the Grenadines', type: 'country' },
  { id: '104031721', name: 'Samoa', type: 'country' },
  { id: '105730022', name: 'San Marino', type: 'country' },
  { id: '106867470', name: 'Sao Tome and Principe', type: 'country' },
  { id: '100459316', name: 'Saudi Arabia', type: 'country' },
  { id: '103587512', name: 'Senegal', type: 'country' },
  { id: '101855366', name: 'Serbia', type: 'country' },
  { id: '107007050', name: 'Seychelles', type: 'country' },
  { id: '106524187', name: 'Sierra Leone', type: 'country' },
  { id: '102454443', name: 'Singapore', type: 'country' },
  { id: '103119917', name: 'Slovakia', type: 'country' },
  { id: '106137034', name: 'Slovenia', type: 'country' },
  { id: '104980134', name: 'Solomon Islands', type: 'country' },
  { id: '104725424', name: 'Somalia', type: 'country' },
  { id: '104035573', name: 'South Africa', type: 'country' },
  { id: '105149562', name: 'South Korea', type: 'country' },
  { id: '103622308', name: 'South Sudan', type: 'country' },
  { id: '105646813', name: 'Spain', type: 'country' },
  { id: '100446352', name: 'Sri Lanka', type: 'country' },
  { id: '106740205', name: 'Sudan', type: 'country' },
  { id: '105530931', name: 'Suriname', type: 'country' },
  { id: '105117694', name: 'Sweden', type: 'country' },
  { id: '106693272', name: 'Switzerland', type: 'country' },
  { id: '106714035', name: 'Syria', type: 'country' },
  { id: '104187078', name: 'Taiwan', type: 'country' },
  { id: '105925962', name: 'Tajikistan', type: 'country' },
  { id: '104604145', name: 'Tanzania', type: 'country' },
  { id: '105146118', name: 'Thailand', type: 'country' },
  { id: '101101678', name: 'Timor-Leste', type: 'country' },
  { id: '103603395', name: 'Togo', type: 'country' },
  { id: '105646927', name: 'Tonga', type: 'country' },
  { id: '106947126', name: 'Trinidad and Tobago', type: 'country' },
  { id: '102134353', name: 'Tunisia', type: 'country' },
  { id: '102105699', name: 'Turkey', type: 'country' },
  { id: '105449295', name: 'Turkmenistan', type: 'country' },
  { id: '103609605', name: 'Tuvalu', type: 'country' },
  { id: '106943612', name: 'Uganda', type: 'country' },
  { id: '102264497', name: 'Ukraine', type: 'country' },
  { id: '104305776', name: 'United Arab Emirates', type: 'country' },
  { id: '101165590', name: 'United Kingdom', type: 'country' },
  { id: '103644278', name: 'United States', type: 'country' },
  { id: '100867946', name: 'Uruguay', type: 'country' },
  { id: '107734735', name: 'Uzbekistan', type: 'country' },
  { id: '102185308', name: 'Vanuatu', type: 'country' },
  { id: '101490751', name: 'Vatican City', type: 'country' },
  { id: '104195383', name: 'Venezuela', type: 'country' },
  { id: '105962095', name: 'Yemen', type: 'country' },
  { id: '102120260', name: 'Zambia', type: 'country' },
  { id: '101367137', name: 'Zimbabwe', type: 'country' },

  // Metropolitan areas / regions
  { id: '90009712', name: 'Berlin Metropolitan Area', type: 'metro' },
  { id: '90010216', name: 'Kyiv Metropolitan Area', type: 'metro' },
  { id: '103173899', name: 'Kyiv City, Ukraine', type: 'metro' },
  { id: '90009496', name: 'London Area, United Kingdom', type: 'metro' },
  { id: '90000049', name: 'Los Angeles Metropolitan Area', type: 'metro' },
  { id: '90009790', name: 'Greater Madrid Metropolitan Area', type: 'metro' },
  { id: '90009735', name: 'Greater Munich Metropolitan Area', type: 'metro' },
  { id: '90000070', name: 'New York City Metropolitan Area', type: 'metro' },
  { id: '104246759', name: 'Île-de-France Region, France', type: 'metro' },
  { id: '106383538', name: 'Paris, France', type: 'metro' },
  { id: '101336206', name: 'Riyadh, Saudi Arabia', type: 'metro' },
  { id: '90000084', name: 'San Francisco Bay Area', type: 'metro' },
  { id: '104769905', name: 'Sydney, New South Wales', type: 'metro' },
  { id: '105076658', name: 'Warsaw, Poland', type: 'metro' },
];

export const GEO_URN_LOCATION_GROUPS: GeoUrnLocationGroup[] = [
  {
    name: 'LATAM + Caribbean',
    locationIds: [
      '100270819',
      '100446943',
      '106662619',
      '102118611',
      '105912732',
      '104379274',
      '106057199',
      '104621616',
      '100876405',
      '101739942',
      '106429766',
      '100720695',
      '105057336',
      '106373116',
      '106522560',
      '104579260',
      '100877388',
      '105836293',
      '100993490',
      '107163060',
      '105126983',
      '103323778',
      '105517145',
      '100808673',
      '104065273',
      '102927786',
      '102098694',
      '104022923',
      '104703990',
      '105530931',
      '106947126',
      '100867946',
      '104195383',
    ],
  },
  {
    name: 'LATAM',
    locationIds: [
      '100446943',
      '105912732',
      '104379274',
      '106057199',
      '104621616',
      '100876405',
      '101739942',
      '106373116',
      '106522560',
      '100877388',
      '105836293',
      '107163060',
      '103323778',
      '105517145',
      '100808673',
      '104065273',
      '102927786',
      '105530931',
      '100867946',
      '104195383',
    ],
  },
  {
    name: 'Europe + Ukraine',
    locationIds: [
      '102845717',
      '106296266',
      '103883259',
      '100565514',
      '102869081',
      '105333783',
      '104688944',
      '106774002',
      '104508036',
      '104514075',
      '102974008',
      '100456013',
      '105015875',
      '101282230',
      '104677530',
      '100288700',
      '105238872',
      '104738515',
      '103350119',
      '104640522',
      '104341318',
      '100878084',
      '101464403',
      '104042105',
      '100961908',
      '106178099',
      '101352147',
      '100733275',
      '102890719',
      '103420483',
      '103819153',
      '105072130',
      '100364837',
      '106670623',
      '105730022',
      '101855366',
      '103119917',
      '106137034',
      '105646813',
      '105117694',
      '106693272',
      '102264497',
      '101165590',
      '101490751',
    ],
  },
  {
    name: 'Balkans',
    locationIds: [
      '102845717',
      '102869081',
      '105333783',
      '104688944',
      '104677530',
      '100733275',
      '103420483',
      '106670623',
      '101855366',
      '106137034',
      '102105699',
    ],
  },
  {
    name: 'Nordic',
    locationIds: ['104514075', '100456013', '105238872', '103819153', '105117694'],
  },
];
